import { LoremIpsum } from "lorem-ipsum";

function generateRandomDate()
{
    return new Date(+(new Date()) - Math.floor(Math.random() * 10000000000));
}

const countries = 
{
    'AF':'Afghanistan',
    'AD':'Andorra',
    'AR':'Argentina',
    'AU':'Australia',
    'AT':'Austria',
    'BE':'Belgium',
    'BR':'Brazil',
    'KH':'Cambodia',
    'CA':'Canada',
    'CN':'China',
    'HR':'Croatia',
    'CZ':'Czech Republic',
    'DK':'Denmark',
    'DO':'Dominican Republic',
    'EG':'Egypt',
    'FI':'Finland',
    'FR':'France',
    'GE':'Georgia',
    'DE':'Germany',
    'GI':'Gibraltar',
    'GR':'Greece',
    'HK':'Hong Kong SAR China',
    'HU':'Hungary',
    'IN':'India',
    'ID':'Indonesia',
    'IE':'Ireland',
    'IL':'Israel',
    'IT':'Italy',
    'JP':'Japan',
    'KE':'Kenya',
    'KW':'Kuwait',
    'LU':'Luxembourg',
    'MO':'Macau',
    'MY':'Malaysia',
    'MT':'Malta',
    'NL':'Netherlands',
    'NZ':'New Zealand',
    'NG':'Nigeria',
    'NO':'Norway',
    'PK':'Pakistan',
    'PA':'Panama',
    'PH':'Philippines',
    'PL':'Poland',
    'PT':'Portugal',
    'RO':'Romania',
    'RU':'Russia',
    'RS':'Serbia',
    'SG':'Singapore',
    'SK':'Slovakia',
    'SI':'Slovenia',
    'ZA':'South Africa',
    'KR':'South Korea',
    'ES':'Spain',
    'SE':'Sweden',
    'CH':'Switzerland',
    'TW':'Taiwan',
    'TH':'Thailand',
    'TR':'Turkey',
    'AE':'United Arab Emirates',
    'GB':'United Kingdom',
    'US':'United States',
    'ZM':'Zambia'
};

const obj_demo =
{
    ok: true,
    json: () =>
    {
        return {
            name: 'Demo',
            surname: 'Demo',
            company: "demo company inc",
            profile: 'Sales',
            telephone: '111111111',
            country: 'IT',
            job: 'My Job',
            active: false
        }
    }
};

const generate_faked_news = (num) =>
{
    const lorem = new LoremIpsum(
    {
        sentencesPerParagraph: {
          max: 8,
          min: 4
        },
        wordsPerSentence: {
          max: 16,
          min: 4
        }
    });
    let tmp = [];
    for(let i=0; i<= num; i++)
    {
        tmp.push(
            {
                date: (new generateRandomDate()).toLocaleDateString('en-US'), 
                title: lorem.generateSentences(2),
                text: lorem.generateParagraphs(1),
                url: '#',
                id: 'id' + i.toString()
            }
        );
    }
    return tmp;
}

const tmp = generate_faked_news(10);
const notificaiton_demo_data = 
{
    ok: true,
    json: () =>
    {
        return tmp;
    }
}

const company_fake_data = 
{
    ok: true,
    json: () =>
    {
        return {
            industry: 'CPG',
            business_sector: 'XXXX',
            country: 'it',
            domains: ['gmail.com', 'tagetik.com'],
            company_code: 'test.client',
            active_users: 2,
            max_users: 3
        }
    }
}

export
{
    company_fake_data,
    notificaiton_demo_data,
    countries,
    obj_demo
};
